<template>
	<div class="myOrderContainer">
		<div class="msg-center-nav">
			<div class="msg-categories">
				<div v-for="category in categories" :key="category.key" class="category-item"
					:class="{ 'active': activeCategory === category.key }" @click="switchCategory(category.key)">
					{{ category.name }}
				</div>
			</div>
		</div>
		<div class="orderListBox">
			<div class="orderMenu">
				<div class="menuItem">订单需求</div>
				<div class="menuItem">商品金额</div>
				<div class="menuItem">实付款</div>
				<div class="menuItem">订单操作</div>
			</div>
			<div class="orderList" v-if="orderList.length">
				<div class="orderItem" v-for="(item,index) in orderList" :key="index">
					<div class="orderItemTop">
						<div class="timeNoDetails">
							<div class="time">{{item.create_time}}</div>
							<div class="no">订单号: {{item.order_sn}}</div>
							<div class="details" @click="naviToDetails(item)">订单详情<img class="arrow"
									src="../assets/MyOrder/iconD.png" /></div>
							<div class="details" style="color: #706614;"
								@click="curOrder = item;dialogReportVisible = true"
								v-if="item.pay_status == 1 && (item.status == 2 || item.status == 3)">查看物流<img
									class="arrow" src="../assets/MyOrder/iconG.png" /></div>
						</div>
						<div class="countdownStatus">
							<countdown :end-time="item.del_time * 1000" v-if="item.pay_status == 0 && item.status != 4">
								<template slot="process" slot-scope="{ timeObj }">
									<div class="countdown">
										<div>{{timeObj.h}}</div>:
										<div>{{timeObj.m}}</div>:
										<div>{{timeObj.s}}</div>后取消订单
									</div>
								</template>
							</countdown>
							<div class="status">{{getMarketStatusName(item)}}</div>
						</div>
					</div>
					<div class="orderItemBottom">
						<div class="checkImgGoodsInfoBox">
							<div class="goodsInfoBox">
								<img class="goodsImg" :src="item.goods_img" />
								<div class="goodsInfo">
									<div class="goodsTitle ellipsis-1">{{item.goods_name}}</div>
									<div class="goodsDesc ellipsis-2">{{item.goods_content}}</div>
									<div class="tips">
										<div class="tip">{{item.cid}}</div>
										<div class="tip">{{item.guige}}</div>
									</div>
								</div>
							</div>
						</div>
						<div class="goodsPrice">
							¥{{item.original_price}}
						</div>
						<div class="costPrice">
							¥{{item.pay_price}}
							<div class="coupon">
								优惠券：-¥{{item.coupon_price}}
							</div>
						</div>
						<div class="operation">
							<div class="apply" v-if="item.pay_status == 1 && item.status == 3 && item.invoice == 0"
								@click="applyInvoice(item)">
								<img src="../assets/MyOrder/iconB.png">
								申请发票
							</div>
							<div class="payNow" v-if="item.pay_status == 0 && item.status != 4" @click="payOrder(item)">
								立即支付</div>
							<div class="cancel" v-if="item.pay_status == 0 && item.status != 4"
								@click="cancelOrder(item)">取消订单</div>
							<div class="payNow" v-if="item.pay_status == 1 && item.status == 2"
								@click="confirmOrder(item)">
								确认收货
							</div>
							<div class="apply" v-if="item.pay_status == 1 && (item.status == 2 || item.status == 3)">
								<img src="../assets/MyOrder/iconJ.png">
								查看样品图
								<el-image style="width:100%;height: 100%;position: absolute;top: 0;left: 0;opacity: 0;"
									:src="item.goods_img" :preview-src-list="item.yp_img"
									v-if="item.yp_img && item.yp_img.length">
								</el-image>
							</div>
							<div class="delete" v-if="item.pay_status == 0 && item.status == 4"
								@click="deleteOrder(item)">删除</div>
						</div>
					</div>
				</div>
			</div>
			<el-empty description="暂无数据" v-else></el-empty>
			<PagePagination style="padding: .2rem 0 0;" :currentPage="currentPage" :total="total"
				@current-change="onPageChange" />
		</div>
		<el-dialog class="reportDialog" :visible.sync="dialogReportVisible" append-to-body
			@close="dialogReportVisible = false">
			<div slot="title">
				<div class="dislogTitle">
					物流信息
				</div>
			</div>
			<div class="dislogConent">
				<div class="wuLiuContent">快递名称：{{curOrder.kd_name}}</div>
				<div class="wuLiuContent">快递单号：{{curOrder.kd_num}}</div>
				<div class="wuLiuContent">备注信息：{{curOrder.kd_content}}</div>
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button plain class="submit" size="medium" @click="dialogReportVisible = false">确定</el-button>
				</div>
			</div>
		</el-dialog>
		<ApplyInvoiceDialog :show="dialogApplyInvoiceViable" :type="2" :orderData="curOrder"
			@close="dialogApplyInvoiceViable = false" @update="sucPop = true;marketOrder()" />
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'提交成功!'" @clickOk="sucPop = false"
			v-if="sucPop" />
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'购买成功！'" :subTitle="'请到个人中心我的订单中查看！'"
			@clickOk="paySucPop = false" v-if="paySucPop" />
		<PayDialog :show="dialogPayViable" :orderType="3" :payUrl="payUrl" :orderId="curOrder.id"
			@close="dialogPayViable = false" @success="paySucPop = true;marketOrder()" />
	</div>
</template>

<script>
	import PopToast from '../components/PopToast.vue'
	import PayDialog from '../components/PayDialog.vue'
	import ApplyInvoiceDialog from '../../src/components/ApplyInvoiceDialog.vue'
	export default {
		components: {
			ApplyInvoiceDialog,
			PayDialog,
			PopToast
		},
		data() {
			return {
				orderList: [],
				// 分类导航
				categories: [{
						key: '0',
						name: '全部'
					},
					{
						key: '1',
						name: '待支付'
					},
					{
						key: '2',
						name: '进行中'
					},
					{
						key: '3',
						name: '已完成'
					},
					{
						key: '4',
						name: '已取消'
					}
				],
				payUrl: '',
				curOrder: {},
				activeCategory: '0',
				sucPop: false,
				currentPage: 1, // 当前页码
				total: 0, // 总条数
				paySucPop: false,
				dialogPayViable: false, //支付
				dialogReportVisible: false,
				dialogApplyInvoiceViable: false,
				deadline4: Date.now() + (new Date().setHours(23, 59, 59) - Date.now()),
			}
		},
		mounted() {
			this.marketOrder()
			console.log(new Date().getTime())
		},
		methods: {
			//申请发票
			applyInvoice(item) {
				this.curOrder = item
				this.dialogApplyInvoiceViable = true
			},
			getMarketStatusName(item) {
				if (item.pay_status == 0) {
					if (item.status == 4) {
						return '已取消'
					} else {
						return '待支付'
					}
				} else {
					if (item.status == 1 || item.status == 2) {
						return '进行中'
					} else if (item.status == 3) {
						return '已完成'
					} else if (item.status == 4) {
						return '已取消'
					}
				}
			},
			naviToDetails(item) {
				this.$router.push({
					path: '/order-details',
					query: {
						type: 3,
						orderId: item.id
					}
				})
			},
			// 切换分类
			switchCategory(category) {
				this.activeCategory = category;
				this.marketOrder()
			},
			//取消订单
			cancelOrder(item) {
				this.$confirm('确认取消当前订单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/Order/order_quxiao', {
						order_id: item.id,
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.marketOrder()
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(() => {

				});
			},
			//删除订单
			deleteOrder(item) {
				this.$confirm('确认删除当前订单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/Order/order_delete', {
						order_id: item.id,
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.marketOrder()
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(() => {

				});
			},
			//确认收货
			confirmOrder(item) {
				this.$confirm('当前订单确认收货吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/Order/order_sh', {
						order_id: item.id,
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.marketOrder()
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(() => {

				});
			},
			//去支付
			payOrder(item) {
				this.$api.post('/Tonglian/order_pay', {
					id: item.id,
				}).then(res => {
					if (res.code == 1) {
						this.curOrder = item
						this.payUrl = res.data
						this.dialogPayViable = true
					}
				}).catch(err => {
					console.log(err);
				})
			},
			onPageChange(newPage) {
				this.currentPage = newPage
				this.marketOrder()
			},
			marketOrder() {
				this.$api.post('/Order/order_list', {
					type: this.activeCategory,
					p: this.currentPage,
				}).then(res => {
					if (res.code == 1) {
						this.total = res.data.count
						this.orderList = res.data.list
					}
				}).catch(err => {
					console.log(err);
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.myOrderContainer {
		display: flex;
		flex-direction: column;
		padding: .24rem .4rem;
	}

	/* 消息分类导航样式 */
	.msg-center-nav {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: .01rem solid rgba(204, 204, 204, .4);
	}

	.msg-categories {
		display: flex;
		gap: .32rem;
	}

	.category-item {
		font-weight: 400;
		font-size: .16rem;
		color: #040404;
		cursor: pointer;
		padding: .24rem 0 .15rem;
		position: relative;
		transition: color 0.3s ease;
	}

	.category-item:hover {
		font-weight: 500;
		font-size: .16rem;
		color: #6B3503;
	}

	.category-item.active {
		font-weight: 500;
		font-size: .16rem;
		color: #6B3503;
	}

	.category-item::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: .02rem;
		background-color: #693200;
		transform: scaleX(0);
		transform-origin: left center;
		transition: transform 0.3s ease;
	}

	.category-item.active::after {
		transform: scaleX(1);
	}

	.orderListBox {
		display: flex;
		flex-direction: column;

		.orderMenu {
			display: flex;
			align-items: center;

			.menuItem {
				height: .5rem;
				font-weight: 400;
				font-size: .14rem;
				color: #666666;
				text-align: center;
				line-height: .5rem;
			}

			.menuItem:nth-child(1) {
				width: 4rem;
			}

			.menuItem:nth-child(2) {
				width: 1.6rem;
			}

			.menuItem:nth-child(3) {
				width: 1.95rem;
			}

			.menuItem:nth-child(4) {
				width: 1.2rem;
			}
		}

		.orderList {
			margin-top: .1rem;
			display: flex;
			flex-direction: column;

			.orderItem {
				display: flex;
				flex-direction: column;

				.orderItemTop {
					height: .4rem;
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 0 .16rem;
					background: #FAEFDD;
					border-radius: .04rem;

					.timeNoDetails {
						display: flex;
						align-items: center;

						.time,
						.no {
							font-weight: 400;
							font-size: .14rem;
							color: #333333;
						}

						.no {
							margin-left: .16rem;
						}

						.details {
							margin-left: .16rem;
							display: flex;
							align-items: center;
							font-weight: 400;
							font-size: .14rem;
							color: #A88653;
							cursor: pointer;

							.arrow {
								margin-left: .04rem;
								width: .05rem;
								height: .08rem;
							}
						}
					}

					.countdownStatus {
						display: flex;
						align-items: center;

						.countdown {
							display: flex;
							align-items: center;
							font-weight: 400;
							font-size: .12rem;
							color: #252525;

							div {
								margin-left: .02rem;
								margin-right: .02rem;
								width: .22rem;
								height: .22rem;
								background: #E29358;
								border-radius: .04rem;
								line-height: .22rem;
								text-align: center;
								font-weight: 500;
								font-size: .12rem;
								color: #252525;
							}
						}

						.status {
							margin-left: .16rem;
							font-weight: 400;
							font-size: .14rem;
							color: #E29358;
						}
					}
				}

				.orderItemBottom {
					padding: .12rem 0 .24rem;
					display: flex;
					align-items: center;

					.checkImgGoodsInfoBox {
						width: 4rem;
						display: flex;
						align-items: center;

						.checkImg {
							width: .18rem;
							height: .18rem;
						}

						.goodsInfoBox {
							display: flex;
							align-items: center;

							.goodsImg {
								width: 1rem;
								height: 1rem;
								border-radius: .08rem;
								overflow: hidden;
								object-fit: cover;
							}

							.goodsInfo {
								width: 2.4rem;
								margin-left: .16rem;
								display: flex;
								flex-direction: column;

								.goodsTitle {
									font-weight: 700;
									font-size: .16rem;
									color: #000000;
									line-height: .22rem;
								}

								.goodsDesc {
									margin-top: .08rem;
									font-weight: 400;
									font-size: .12rem;
									color: #333333;
									line-height: .16rem;
								}

								.tips {
									margin-top: .12rem;
									display: flex;
									align-items: center;

									.tip {
										margin-right: .1rem;
										height: .26rem;
										padding: 0 .08rem;
										border-radius: .13rem;
										border: .01rem solid #A88653;
										line-height: .24rem;
										font-weight: 400;
										font-size: .12rem;
										color: #7C3E0B;
									}
								}
							}
						}
					}


				}

				.goodsPrice {
					width: 1.6rem;
					font-weight: 400;
					font-size: .14rem;
					color: #000000;
					text-align: center;
				}

				.costPrice {
					width: 1.95rem;
					display: flex;
					flex-direction: column;
					align-items: center;
					font-weight: 400;
					font-size: .14rem;
					color: #000000;

					.coupon {
						margin-top: .04rem;
						font-size: .12rem;
						color: #999999;
					}
				}

				.operation {
					width: 1.2rem;
					display: flex;
					flex-direction: column;
					align-items: center;

					.download,
					.payNow {
						width: .88rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						line-height: .36rem;
						text-align: center;
						cursor: pointer;
					}

					.apply {
						margin-top: .12rem;
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .12rem;
						color: #333333;
						cursor: pointer;
						position: relative;

						img {
							margin-right: .04rem;
							width: .12rem;
							height: .12rem;
						}
					}

					.cancel {
						margin-top: .12rem;
						font-weight: 400;
						font-size: .12rem;
						color: #999999;
						cursor: pointer;
					}

					.delete {
						width: .88rem;
						height: .36rem;
						border-radius: .04rem;
						border: .01rem solid #E29358;
						font-weight: 400;
						font-size: .14rem;
						color: #E29358;
						line-height: .36rem;
						text-align: center;
						cursor: pointer;
					}
				}
			}
		}
	}

	.reportDialog {

		::v-deep .el-dialog {
			width: 4.58rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;


				.wuLiuContent {
					margin-bottom: .16rem;
					font-weight: 400;
					font-size: .14rem;
					line-height: .2rem;
					color: #252525;
				}

				.el-form {

					&-item:nth-child(4),
					&-item:nth-child(5) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							width: 1.1rem;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .16rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: 0 auto;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>